<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [applicationId]="applicationId"
  #formActivityInputView
></wm-form-activity-input-view>


 @if (canceledInAnotherActivity) {
  @if (!templateForPermitForm) {
    <div class="m-1 text-warning">
      This inspection appointment was canceled by {{ existingCancelReason.modifiedBy }} on {{ existingCancelReason.modifiedOnString }}
    </div>
  } @else {
    <wm-common-text
      [data]="{ text: 'This inspection appointment was canceled by ' + existingCancelReason.modifiedBy + ' on ' + existingCancelReason.modifiedOnString }"
      class="m-1 text-warning"
    ></wm-common-text>
  }
}

@if (bypassedInAnotherActivity) {
  @if (!templateForPermitForm) {
    <div class="m-1 text-warning">
      This inspection was bypassed by {{ existingBypassReason.modifiedBy }} on {{ existingBypassReason.modifiedOnString }}
    </div>
  } @else {
    <wm-common-text
      [data]="{ text: 'This inspection was bypassed by ' + existingBypassReason.modifiedBy + ' on ' + existingBypassReason.modifiedOnString }"
      class="m-1 text-warning"
    ></wm-common-text>
  }
}

<div *ngIf="rescheduleSelected">
  <div [formGroup]="rescheduleForm">
    <div class="row mt-3">
      <div class="col">
        
        @if (!templateForPermitForm) {
          <strong>
            When Reschedule is selected, the next activity will be {{ activity.model.scheduleActivityScreenName }}. An email notification will be sent to the {{ scheduleActivityResponsibleRole }}, and it will include the reason for rescheduling, which must be provided here:
          </strong>
          
          <textarea
            style="height:100px"
            id="rescheduleReason"
            name="rescheduleReason"
            class="form-control my-2"
            formControlName="rescheduleReason"
            aria-label="Reschedule Reason"
            [(ngModel)]="activity.model.rescheduleReason.value"
          ></textarea>

          <wm-control-message
            [control]="rescheduleForm.controls['rescheduleReason']"
          ></wm-control-message>

        } @else {
          <wm-common-text
            [data]="{ text: 'When Reschedule is selected, the next activity will be ' + activity.model.scheduleActivityScreenName + '. An email notification will be sent to the ' + scheduleActivityResponsibleRole + ', and it will include the reason for rescheduling, which must be provided here:' }"
            class="header mb-2 d-block"
          ></wm-common-text>

          <wm-common-textfield
            [data]="{
              label: 'Reschedule Reason',
              type: 'text-area',
              textAreaRows: 4,
              required: true,
              value: activity.model.rescheduleReason.value,
              placeholder: 'Enter reason here...'
            }"
            [control]="rescheduleForm.controls['rescheduleReason']"
          ></wm-common-textfield>
        }

      </div>
    </div>
  </div>
</div>

<div *ngIf="cancelSelected">
  <div [formGroup]="cancelForm">
    <div class="row mt-3">
      <div class="col">
        
        @if (!templateForPermitForm) {
          <strong>
            When Cancel Inspection Appointment is selected, the next activity will be {{ activity.model.requestActivityScreenName }}. An email notification will be sent to the {{ requestActivityResponsibleRole }}, and it will include the reason for canceling, which must be provided here:
          </strong>
          
          <textarea
            style="height:100px"
            id="cancelReason"
            name="cancelReason"
            class="form-control my-2"
            formControlName="cancelReason"
            aria-label="Cancel Reason"
            [(ngModel)]="activity.model.cancelReason.value"
          ></textarea>

          <wm-control-message
            [control]="cancelForm.controls['cancelReason']"
          ></wm-control-message>

        } @else {
          <wm-common-text
            [data]="{ text: 'When Cancel Inspection Appointment is selected, the next activity will be ' + activity.model.requestActivityScreenName + '. An email notification will be sent to the ' + requestActivityResponsibleRole + ', and it will include the reason for canceling, which must be provided here:' }"
            class="header mb-2 d-block"
          ></wm-common-text>

          <wm-common-textfield
            [data]="{
              label: 'Cancel Reason',
              type: 'text-area',
              textAreaRows: 4,
              required: true,
              value: activity.model.cancelReason.value,
              placeholder: 'Enter reason here...'
            }"
            [control]="cancelForm.controls['cancelReason']"
          ></wm-common-textfield>
          
          }

      </div>
    </div>
  </div>
</div>

<div *ngIf="bypassSelected">
  <div [formGroup]="bypassForm">
    <div class="row mt-3">
      <div class="col">
        
        @if (!templateForPermitForm) {
          <strong>
            When Bypass is selected, the application will proceed to the next activity. Please provide the reason for bypassing:
          </strong>
          
          <textarea
            style="height:100px"
            id="bypassReason"
            name="bypassReason"
            class="form-control my-2"
            formControlName="bypassReason"
            aria-label="Bypass Reason"
            [(ngModel)]="activity.model.bypassReason.value"
          ></textarea>

          <wm-control-message
            [control]="bypassForm.controls['bypassReason']"
          ></wm-control-message>

        } @else {
          <wm-common-text
            [data]="{ text: 'When Bypass is selected, the application will proceed to the next activity. Please provide the reason for bypassing:' }"
            class="header mb-2 d-block"
          ></wm-common-text>

          <wm-common-textfield
            [data]="{
              label: 'Bypass Reason',
              type: 'text-area',
              textAreaRows: 4,
              required: true,
              value: activity.model.bypassReason.value,
              placeholder: 'Enter reason here...'
            }"
            [control]="bypassForm.controls['bypassReason']"
          ></wm-common-textfield>
        }

      </div>
    </div>
  </div>
</div>
